import React from "react";
import styled from "styled-components";
import Button from "common/Button";
import { client } from "shared/apiClient";
import { useState, useEffect } from "react";
import qs from "query-string";
import { CWBAPI, CWBLoadingCrest } from "cwb-react";
import TWBLogoGrey from "images/icon-twb-logo-grey.svg";
import { redirectAuthenticated } from "../../shared/helpers";
import { withI18n } from "react-i18next";


function NewPresentation(props) {
  const [isAgentDataLoading, setAgentDataLoading] = useState(true);
  // const [tokenData, setTokenData] = useState({}); // todo: use cwb localstorage saving
  const [userData, setUserData] = useState({});
  const [agentData, setAgentData] = useState({});
  const params = qs.parse(props.location.search);

  useEffect(() => {
    const fetchData = async () =>  {
      let api = await import(`cwb-react/dist/${CWB_API_FILE}`);
      let localApi = await import(`shared/api`);
      client.api = new CWBAPI(
        { ...api.default, ...localApi.default },
        CWB_API_ENV,
        CWB_USE_MOCK_ENV
      );

      let authResp;
      let userResp;
      let agentResp;

      try {
        authResp = await client.api.user.postBridgeAuthTokenFromSession(params.k || params.tk);
        // setTokenData(authResp.data);
        client.api.axios.defaults.headers.common.Authorization = `Bearer ${authResp.data.accessToken}`;
      } catch (e) {
        // not authed but aPath might still be valid, send back to login with search params
        props.history.push(`/login?${qs.stringify(params)}`);
      }

      try {
        userResp = await client.api.auth.getUserData();
        setUserData(userResp.data);

        if (userResp.data?.id?.userTypeId !== 8) {
          redirectUserToTheirIndexPage(userResp.data.id.userId, true);
          return;
        }
      } catch (e) {
        props.history.push(`/login?${qs.stringify(params)}`);
      }

      try {
        agentResp = await client.api.invitation.checkInvitationValidity(params.aPath);

        setAgentData(agentResp.data);

        if (
          !agentResp.data.isValid
          || agentResp.data.notFound
        ) {
          throw new Error('Invalid invite');
        }
      } catch(e) {
        redirectUserToTheirIndexPage(userResp.data.id.userId, true);
        return;
      }

      setAgentDataLoading(false);
    }
    
    fetchData();
  }, []);

  async function onSubmit() {
    setAgentDataLoading(true);
    try {
      await client.api.invitation.addAgent(
        userData.id.userId,
        {
          agencyId: agentData.agencyId,
          agentId: agentData.agentId,
        },
      );
    } catch(e) {
      // redirect
      console.error(e);
      setAgentDataLoading(false);
    } finally {
      redirectUserToTheirIndexPage(userData.id.userId);
    }
  }

  function redirectUserToTheirIndexPage(userId, replace=false) {
    setAgentDataLoading(true);
    let webSessionKey = params.k || params.tk;
    if (!webSessionKey.startsWith("{")) {
      webSessionKey = "{" + webSessionKey + "}";
    }

    const queryStringData = { ...params, k: webSessionKey };

    queryStringData.tk = webSessionKey;
    queryStringData.cid = userId;

    if (!queryStringData.page && (queryStringData.redirect)) {
      queryStringData.page = queryStringData.redirect;
    }

    const defaultActorRedirect = `${CWB_API_ENV.domain}/actorsworkbook/default.asp?${qs.stringify(queryStringData)}`;

    if (replace) {
      window.location.replace(defaultActorRedirect);
    } else {
      window.location.href = defaultActorRedirect;
    }
  };


  if (isAgentDataLoading) {
    return (
      <CWBLoadingCrest customLogoSrc={TWBLogoGrey} />
    );
  }

  return (
    <Wrapper>
      <Frame>
        <H1>{props.t('New representation')}</H1>
        {agentData.logoUrl
          ? <PhotoWrapper>
              <Photo src={agentData.logoUrl}/>
            </PhotoWrapper>
          : null
        }
        <InfoText><b>{props.t('Company')}:</b> {agentData.company}</InfoText>
        <InfoText><b>{props.t('Agent')}:</b> {agentData.firstName} {agentData.lastName}</InfoText>
      </Frame>
      <ButtonList>
        <Button variant='secondary' onClick={onSubmit}>{props.t('Looks good')}</Button>
        <Button
          variant='secondary'
          onClick={() => redirectUserToTheirIndexPage(
            userData.id.userId,
          )}
          destructive
        >{props.t('Skip')}</Button>
      </ButtonList>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  padding-top: 59px;
  max-width: 295px;
  margin: 0 auto;
`;

const Frame = styled.div`
  background: white;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  padding: 24px 24px 40px;
`;

const PhotoWrapper = styled.div`
  max-width: 120px;
  margin: 0 auto;
  margin-bottom: 16px;
`;

const Photo = styled.img`
  // max-width: 247px;
  // min-width: 247px;
  // max-height: 309px;
  // min-height: 309px;
  width: 100%;
`;

const H1 = styled.h1`
  font-size: 16px;
  font-weight: bold;
  color: #0A1F44;
  margin-bottom: 18px;
  text-align: center;
`;

const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  margin: 0 0 4px;

  & > b{
    color: #0A1F44;
  }
`;

const ButtonList = styled.div`
  display: flex;
  flex-flow: nowrap row;
  margin-top: 20px;
  gap: 8px;

  & > button{
    flex: 1;
  }
`;

export default withI18n()(NewPresentation);
